export type OperatedInValue = string | string[] | null | undefined;

export const formatLanguage = (language: string) =>
  language
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const normalizeOperatedInLanguages = (operatedIn: OperatedInValue): string[] => {
  const languages = Array.isArray(operatedIn) ? operatedIn : operatedIn ? operatedIn.split(',') : [];

  return languages.map(formatLanguage).filter(Boolean);
};

export const getOperatedInSummary = (operatedIn: OperatedInValue) => {
  const [primaryLanguage, ...additionalLanguages] = normalizeOperatedInLanguages(operatedIn);

  return {
    primaryLanguage,
    additionalLanguages,
    additionalCount: additionalLanguages.length,
  };
};
